module.exports = "/img/_/_/_/assets/images/creeper/battle/common//46.jpg?49b4923ac710cc096ce6ad4d2cf7809a";